import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {combineLatest, BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {InstanceService} from './instance.service';

const APP_NAME = 'MO-RENA';

/**
 * Setzt den Tab-Titel nach dem Schema "Seite - Instanzname | MO-RENA".
 * Der Seitenname kommt aus `data.title` der aktuellen Route und kann mit `setPage()` überschrieben werden.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
    private page = new BehaviorSubject<string | null>(null);

    constructor(private router: Router, private route: ActivatedRoute, private title: Title, private instance: InstanceService) {
        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => this.page.next(this.routeTitle()));

        combineLatest(this.page, this.instance.name$())
            .subscribe(([page, name]) => this.title.setTitle(
                [page, name].filter(x => !!x).join(' - ') + (page || name ? ` | ${APP_NAME}` : APP_NAME)
            ));
    }

    /** Überschreibt den Seitennamen der aktuellen Route, z.B. mit der Studiennummer. */
    setPage(page: string) {
        this.page.next(page);
    }

    private routeTitle(): string | null {
        let current = this.route.snapshot;
        let title: string | null = null;
        while (current) {
            if (current.data && current.data.title) {
                title = current.data.title;
            }
            current = current.firstChild;
        }
        return title;
    }
}
